import { useContext, useState } from 'react';

import {
  Box,
  Hidden,
  IconButton,
  Tooltip,
  Typography,
  toolbarClasses
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import CloseIcon from '@mui/icons-material/Close';
import HeaderMenu from './Menu';
import HeaderButtons from './Buttons';
import HeaderUserbox from './Userbox';
import Logo from 'src/components/Logo';
import { CollapseContext } from 'src/contexts/CollapseContext';
import MenuIcon from '@mui/icons-material/Menu';
import HeaderNotifications from './Buttons/Notifications';
import Calendar from './calendar';
import HelpBox from './help-box';

const Header = ({ menuItemHandler }) => {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { collapseToggle, toggleCollapse } = useContext(CollapseContext);

  const environment = process.env.REACT_APP_ENV;

  const HeaderWrapper = styled(Box)(
    ({ theme }) => `
          height: ${theme.header.height};
          color: ${theme.header.textColor};
          padding: ${theme.spacing(0, 2)};
          right: 0;
          z-index: 5;
          background-color: ${theme.header.background};
          box-shadow: ${theme.header.boxShadow};
          position: fixed;
          justify-content: space-between;
          width: auto;
          left: ${!collapseToggle ? '50px' : '250px'};
          @media (max-width: 1024px) {
            left: 0;
            width: auto;
        }
  `
  );

  const onClickMenuItemHandler = () => {
    toggleCollapse();
    if (window.innerWidth < 1001) {
      menuItemHandler(true);
    }
  };


  return (
    <HeaderWrapper display="flex" alignItems="center" style={{ height: 50 }}>
      <Box display="flex" alignItems="center">
        <MenuIcon
          style={{ cursor: 'pointer' }}
          onClick={onClickMenuItemHandler}
        />
        {environment !== 'prod' &&
        <Typography component="span" color="text.primary" ml={4} fontWeight='bold'>
          {environment === 'dev' ? 'DEVELOPMENT Environment' : 'QA Environment'}
        </Typography>
        }
        <Hidden lgUp>
          <Logo />
        </Hidden>
        <Hidden mdDown>
          <HeaderMenu />
        </Hidden>
      </Box>
      <Box display="flex" alignItems="center">
        <Calendar/>
        <HelpBox/>
        <HeaderNotifications/> 
        <HeaderUserbox/>
      </Box>
    </HeaderWrapper>
  );
};

export default Header;
